export const MIRANA_SERVICE = 'MIRANA_SERVICE';
export const ACCESS_TOKEN = 'mrnAccessToken';

export interface IFuerzaVenta {
    id: string;
    descripcion: string;
    almacenId: string;
    abbrv: string;
}

export const FuerzasVenta = Object.freeze({
    GLORIA: {id: '0040', descripcion: 'GLORIA', almacenId: '0002', abbrv: 'gl'} as IFuerzaVenta,
    SAN_FERNANDO: {id: '0039', descripcion: 'SAN FERNANDO', almacenId: '0003', abbrv: 'sf'} as IFuerzaVenta,
    KIMBERLY: {id: '0045', descripcion: 'KIMBERLY', almacenId: '9990', abbrv: 'kb'} as IFuerzaVenta,
    STANLEY: {id: '0044', descripcion: 'STANLEY', almacenId: '9991', abbrv: 'stl'} as IFuerzaVenta,
    AUREN2: {id: '0056', descripcion: 'AUREN 2', almacenId: '9991', abbrv: 'stl'} as IFuerzaVenta,
    NEXO: {id: '0053', descripcion: 'NEXO', almacenId: '9992', abbrv: 'nx'} as IFuerzaVenta,
    GLORIA_NORTE: {id: '0052', descripcion: 'GLORIA', almacenId: '0002', abbrv: 'gl'} as IFuerzaVenta,
});

export const VisicoolerModeloEstado = Object.freeze({
    ACTIVO: 1,
    INACTIVO: 2
});

export const Meses = Object.freeze([
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Setiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
    ]
);


// WEBPACK FOOTER //
// ./src/utils/constants.ts